export const CDN_FEATURES: string[] = [
  'DDoS and bot protection',
  'Web Application Firewall',
  'Mobile optimization with Mirage',
  'Cloudflare SSL',
];
